module.exports = __webpack_public_path__ + "img/download-gray.0a48628d.svg";